var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("single-select-accessible", {
        attrs: {
          title: "ContinuousReport.MetersAndMonitoring.Type",
          options: _vm.optionsArray("MeterTypeOptions", true),
          required: true,
          dropdownId: "meterType_" + _vm.index
        },
        model: {
          value: _vm.meter.type,
          callback: function($$v) {
            _vm.$set(_vm.meter, "type", $$v)
          },
          expression: "meter.type"
        }
      }),
      _vm._v(" "),
      _vm.showDescription
        ? _c("text-area-row", {
            attrs: {
              title: "ContinuousReport.MetersAndMonitoring.Description",
              id: "meterdescription_" + _vm.index,
              required: true,
              maxLength: 50,
              rows: 1,
              hideCharsLeft: true,
              noResize: true
            },
            model: {
              value: _vm.meter.description,
              callback: function($$v) {
                _vm.$set(_vm.meter, "description", $$v)
              },
              expression: "meter.description"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("single-select-accessible", {
        attrs: {
          title: "ContinuousReport.MetersAndMonitoring.MeasurementMethod",
          options: _vm.optionsArray("MeasurementMethodOptions", true),
          required: true,
          dropdownId: "meterMeasurementMethod_" + _vm.index
        },
        model: {
          value: _vm.meter.measurementMethod,
          callback: function($$v) {
            _vm.$set(_vm.meter, "measurementMethod", $$v)
          },
          expression: "meter.measurementMethod"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "ContinuousReport.MetersAndMonitoring.AskedCount",
          id: "askedcount_" + _vm.index,
          required: true
        },
        model: {
          value: _vm.meter.askedCount,
          callback: function($$v) {
            _vm.$set(_vm.meter, "askedCount", $$v)
          },
          expression: "meter.askedCount"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "ContinuousReport.MetersAndMonitoring.AnswerCount",
          id: "answercount_" + _vm.index,
          required: true
        },
        model: {
          value: _vm.meter.answerCount,
          callback: function($$v) {
            _vm.$set(_vm.meter, "answerCount", $$v)
          },
          expression: "meter.answerCount"
        }
      }),
      _vm._v(" "),
      _vm.hasTargets
        ? _c("check-box-dialog-row", {
            attrs: {
              id: "meterTargetsDialog" + _vm.index,
              title: "ContinuousReport.MetersAndMonitoring.TargetsRelated",
              buttonLabel: "ContinuousReport.Button.SelectTarget",
              displayOptionNames: false,
              required: true,
              options: _vm.targets
            },
            model: {
              value: _vm.meter.targets,
              callback: function($$v) {
                _vm.$set(_vm.meter, "targets", $$v)
              },
              expression: "meter.targets"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("check-box-dialog-row", {
        attrs: {
          id: "meterTargetGroupsDialog" + _vm.index,
          title: "ContinuousReport.MetersAndMonitoring.TargetGroupsRelated",
          buttonLabel: "ContinuousReport.Button.SelectTargetGroup",
          displayOptionNames: true,
          required: true,
          options: _vm.targetGroups
        },
        model: {
          value: _vm.meter.targetGroups,
          callback: function($$v) {
            _vm.$set(_vm.meter, "targetGroups", $$v)
          },
          expression: "meter.targetGroups"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "ContinuousReport.MetersAndMonitoring.Change",
          id: "meterchange_" + _vm.index,
          required: true,
          maxLength: 500,
          rows: 3
        },
        model: {
          value: _vm.meter.change,
          callback: function($$v) {
            _vm.$set(_vm.meter, "change", $$v)
          },
          expression: "meter.change"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }